import React from 'react'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../../atoms/ComponentBox/BoxWithIcon";
import { useLocation ,useNavigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Checkouthandover=()=>{
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);
    const hasModulePermission = (moduleName) => {
      const modulePermission = permissions.find(
        permission => permission.ModuleName === moduleName
      );
      
      if (!modulePermission) return false;
  
      return (
        modulePermission.AddRec === "1" ||
        modulePermission.EditRec === "1" ||
        modulePermission.DeleteRec === "1" ||
        modulePermission.ViewRec === "1"
      );
    };
    return(
        <>
       <Box sx={{ flexGrow: 1 }}>
      <Grid container sx={{
        '& .MuiGrid-root': {
          width: 'calc(90% + 16px)'
        }
      }}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
          {/* {hasModulePermission("Registration") && ( */}
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link={{ pathname: '/enquiry/checkout-artical' }}
            //   permissions={permissions}
              title="Checkout artical handover"
            />
            {/* )} */}
            {/* {hasModulePermission("KYC") && ( */}
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              // link="#"
              link={{ pathname: '/enquiry/checkoutduetable' }}
            //   permissions={permissions}
              title="Checkout dues"
            />
            {/* )} */}
             {/* {hasModulePermission("OnBoarding & Handover") && ( */}
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link={{ pathname: '' }}
            //   permissions={permissions}
              title="Checkout"
            />
            {/* )} */}
          </Grid>
        </Grid>
      </Grid>
    </Box>
        </>
    )
}
export default Checkouthandover